import { t as e } from "../../chunks/index.es.CfT5btWg.js";
import { Element as t, Node as n, Transforms as r } from "slate";
//#region lib/Link/lib/normalizeNode.ts
var i = (i, a) => {
	let [o, s] = a;
	if (!(!t.isElement(o) || !e.isOfType(o, "core/link")) && n.string(o).trim() === "") return r.unwrapNodes(i, {
		at: s,
		match: (n) => t.isElement(n) && e.isOfType(n, "core/link")
	}), !0;
};
//#endregion
export { i as normalizeNode };
